import { render } from "./FmRead.vue?vue&type=template&id=72d75619&scoped=true&ts=true"
import script from "./FmRead.vue?vue&type=script&lang=ts"
export * from "./FmRead.vue?vue&type=script&lang=ts"

import "./FmRead.vue?vue&type=style&index=0&id=72d75619&lang=less&scoped=true"

import exportComponent from "D:\\waibao\\lsjy-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d75619"]])

export default __exports__